/**
 * @file   src\mobile\components\CheckDeleteAccountModal.js
 * @brief  This file is responsible for showing account deleted popup
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
const CheckDeleteAccountModal = (props) => {
  const { show, onHide } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modalPopupstyle delete-popup"
    >
      <Modal.Body className="text-center">
        <h3>Check your email</h3>
        <p>
          We've sent links to your email account where you can confirm account
          deletion.
        </p>
        <div></div>
        <div className="btn-wrap">
          <Button
            variant="primary"
            className="btn btn-primary w-100"
            onClick={() => onHide()}
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default CheckDeleteAccountModal;
